import { Box } from '@mui/system';
import React, { FC } from 'react';
import { IWizardActionsButtonsProps } from 'types/wizard';

const WizardActionsButtons: FC<IWizardActionsButtonsProps> = ({
	actionButton,
	backButton
}) => (
	<Box
		display="flex"
		flexDirection="row"
		alignItems="flex-start"
		justifyContent="flex-end"
		data-testid="wizard-actions-buttons"
	>
		{backButton && <Box pr={4}>{backButton}</Box>}
		{actionButton}
	</Box>
);

export default WizardActionsButtons;
